import{jsx as o}from"react/jsx-runtime";import{Fonts as t}from"@vds-core/typography";import{calculateRem as e}from"@vds-core/utilities";import{AccessibilityTokens as r}from"@vds-tokens/accessibility";import{ColorTokens as n}from"@vds-tokens/color";import{TypographyTokens as a}from"@vds-tokens/typography";import i,{css as c}from"styled-components";const l=c`
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  transition: color 0.15s ease-out;
  position: relative;
  cursor: pointer;
  font-family: ${t.VerizonNHGeTX};
  font-size: ${e(a.fontsize.body[12].value)};
  font-weight: ${a.fontweight.regular.value};
  line-height: ${e(a.lineheight.body[16].value)};
  color: ${function({color:o}){return o}};
  text-decoration: none;
  outline: none;
  ${function({surface:o}){return`\n      &:focus:not(:hover) {\n        outline: none;\n        &::before {\n          border: ${e(r.focusring.borderwidth.value)} ${r.focusring.borderstyle.value} ${"dark"===o?r.color.focusring.ondark.value:r.color.focusring.onlight.value};\n          border-radius: '2px';\n          content: '';\n          height: calc(100% + ${e(parseInt(r.focusring.space.offset.value,10)+parseInt(r.focusring.borderwidth.value,10))});\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ${e(4)});\n        }\n      }\n  `}};
  &:active {
    color: ${function({surface:o}){return"dark"===o?n.interactive.active.ondark.value:n.interactive.active.onlight.value}};
  }
  box-sizing: border-box;
  &:hover:not(:active) {
    &::before {
      background: ${function({surface:o}){return"dark"===o?n.elements.primary.ondark.value:n.elements.primary.onlight.value}};
      position: absolute;
      box-shadow: none;
      content: '';
      height: 1px;
      bottom: 0;
      width: 100%;
      z-index: 1;
    }
  }
`,s=i.a.withConfig({displayName:"StyledAnchor",componentId:"VDS__sc-6ss44u-0"})`
  ${l};
`,u=i.button.withConfig({displayName:"StyledButton",componentId:"VDS__sc-6ss44u-1"})`
  ${l};
  background: transparent;
  border: none;
  padding: 0;
`,d=function(t){const{href:e,children:r,ariaLabel:a,surface:i,color:c,"data-analyticstrack":l,"data-track":d,"data-track-ignore":f,"data-clickstream":p}=t;return o(e?s:u,{href:e,"aria-label":a,role:e?"link":"button",tabIndex:0,onClick:function(o){var e;"click"===o.type&&o.currentTarget.blur(),null===(e=t.onClick)||void 0===e||e.call(t,o)},color:"dark"===i?n.elements.primary.ondark.value:n.elements.primary.onlight.value,surface:i,"data-analyticstrack":l,"data-track":d,"data-track-ignore":f,"data-clickstream":p,children:r})};export{d as default};
